import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialHealthDistrictState: Dtos.HealthDistrict & IRegistrationFormState = {
    id: null,
    name: null,
    stateId: null,
    state: null,
    rank: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    active: null,
    saveAndReturn: false
}

export interface IHealthDistrictReduxFormState {
    id: IFieldState<number>,
    name: IFieldState<string>,
    stateId: IFieldState<number>,
    state: IFieldState<Dtos.State>,
    rank: IFieldState<number>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    active: IFieldState<boolean>
}
